import type { IconName } from '@garnet/ui';

/** Every console route. The hash router matches against this closed set. */
export const ROUTES = [
  'dash',
  'flow',
  'record',
  'requirements',
  'inbox',
  'renewals',
  'cases',
  'professional',
  'translation',
  'tpm',
  'prodesk',
  'settings',
  'advisor',
] as const;
export type Route = (typeof ROUTES)[number];

export interface NavItem {
  k: Route;
  label: string;
  icon: IconName;
  primary?: boolean;
  badge?: string;
  advisor?: boolean;
}
export interface NavGroup {
  grp: string;
  items: NavItem[];
}

/** Sidebar, grouped (PRD nav spine): Diligence · Monitoring · Network · System · Reference. */
export const NAV: NavGroup[] = [
  {
    grp: 'Diligence',
    items: [
      { k: 'flow', label: 'Start a diligence', icon: 'plus', primary: true },
      { k: 'dash', label: 'Dashboard', icon: 'eye' },
      { k: 'record', label: 'Supplier record', icon: 'file' },
      { k: 'requirements', label: 'Requirements', icon: 'exchange', badge: '3' },
      { k: 'inbox', label: 'Document inbox', icon: 'upload', badge: '5' },
    ],
  },
  {
    grp: 'Monitoring',
    items: [
      { k: 'renewals', label: 'Renewals', icon: 'clock', badge: '4' },
      { k: 'cases', label: 'Case queue', icon: 'alert', badge: '4' },
    ],
  },
  {
    grp: 'Network',
    items: [
      { k: 'professional', label: 'Professional requests', icon: 'link' },
      { k: 'translation', label: 'Translation services', icon: 'book' },
      { k: 'tpm', label: 'TPM classification', icon: 'filter' },
      { k: 'prodesk', label: 'Professional desk', icon: 'briefcase' },
    ],
  },
  {
    grp: 'System',
    items: [{ k: 'settings', label: 'Settings · integrations', icon: 'refresh' }],
  },
  {
    grp: 'AI Advisor',
    items: [{ k: 'advisor', label: 'Advisor & Copilot', icon: 'chat', advisor: true }],
  },
];

/** Breadcrumb text per route (group · screen). */
export const CRUMB: Record<Route, string> = {
  dash: 'Diligence · Dashboard',
  flow: 'Diligence · Start a diligence',
  record: 'Diligence · Supplier record',
  requirements: 'Diligence · Requirements',
  inbox: 'Diligence · Document inbox',
  renewals: 'Monitoring · Renewals',
  cases: 'Monitoring · Case queue',
  professional: 'Network · Professional requests',
  translation: 'Network · Translation services',
  tpm: 'Network · TPM classification',
  prodesk: 'Network · Professional desk',
  settings: 'System · Settings · integrations',
  advisor: 'AI Advisor',
};
